module.exports = __webpack_public_path__ + "static/media/relaxAndStudyDark.7b440dd6.gif";